import { useMemo, useCallback } from "react";
import { MutationsObject, QueriesObject } from "../context/ContractorContext";

export const useContractorError = (
  queries: QueriesObject,
  mutations: MutationsObject,
) => {
  const errorState = useMemo(() => {
    const queryError = queries.contractorQuery.error;
    const mutationError =
      mutations.activateContractorMutation.error ||
      mutations.deactivateContractorMutation.error ||
      mutations.updateContractorMutation.error ||
      mutations.deleteContractorMutation.error;

    const error = queryError || mutationError;
    const isQuery = !!queryError;

    return { error, isQuery };
  }, [
    queries.contractorQuery.error,
    mutations.activateContractorMutation.error,
    mutations.deactivateContractorMutation.error,
    mutations.updateContractorMutation.error,
    mutations.deleteContractorMutation.error,
  ]);

  const clearError = useCallback(() => {
    mutations.activateContractorMutation.reset();
    mutations.deactivateContractorMutation.reset();
    mutations.updateContractorMutation.reset();
    mutations.deleteContractorMutation.reset();
  }, [
    mutations.activateContractorMutation,
    mutations.deactivateContractorMutation,
    mutations.updateContractorMutation,
    mutations.deleteContractorMutation,
  ]);

  return { errorState, clearError };
};
